import React from 'react';
import Timestamp from '../shared/Timestamp';
import { documentNames } from '../../../models/LibraryModel';
import { formatDuration } from '../../../models/AssessmentsModel';

function Field({ label, children }) {
  return (
    <div>
      <div className="assessment-detail-label">{label}</div>
      <div className="assessment-detail-value">{children}</div>
    </div>
  );
}

/**
 * The assessment's own fields and the documents its scenario binds. It is the
 * whole body while a record is Uploading, Queued or Failed, and the Overview
 * tab once it is evaluating. Built on a transcript there is no Duration: a
 * transcript carries no times to take one from.
 */
function AssessmentOverview({ assessment, scenario, documents }) {
  const fromTranscript = assessment.source === 'transcript';
  const names = (ids) => documentNames(documents, ids || []);
  const keys = scenario ? names(scenario.referenceKeyIds) : [];
  const sops = scenario ? names(scenario.sopIds) : [];
  const narrative = scenario && scenario.narrativeId ? names([scenario.narrativeId]) : [];

  return (
    <>
      <div className="assessment-detail-meta">
        <Field label={fromTranscript ? 'Transcript' : 'Recording'}>{assessment.fileName}</Field>
        {!fromTranscript && <Field label="Duration">{formatDuration(assessment.durationSec)}</Field>}
        <Field label="Uploaded"><Timestamp value={assessment.uploadedAt} form="long" /></Field>
        <Field label="Scenario">{scenario ? scenario.name : '-'}</Field>
      </div>
      {scenario && (
        <>
          <h3 className="assessment-detail-section-title">Scenario documents</h3>
          <div className="assessment-detail-meta">
            <Field label={keys.length > 1 ? 'Reference keys' : 'Reference key'}>{keys.join(', ') || '-'}</Field>
            <Field label={sops.length > 1 ? 'SOPs' : 'SOP'}>{sops.join(', ') || '-'}</Field>
            <Field label="Narrative">{narrative[0] || '-'}</Field>
          </div>
        </>
      )}
    </>
  );
}

export default AssessmentOverview;
